import React from "react";
//#region types
import { StyleEnums } from "models/enums";
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
import { DividendSpaceWarningProps } from "models/propTypes/annualAccountPropTypes";
//#endregion
//#region components
import { SimpleMessage } from "components/common";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

const DividendSpaceWarning: React.FC<DividendSpaceWarningProps> = ({ dividendProposal, dividendAmount }) => {
  const exceedsDividendProposal = dividendProposal !== undefined && (dividendAmount ?? 0) > dividendProposal;

  return exceedsDividendProposal ? (
    <SimpleMessage
      icon={IconDefinitionConstants.WExclamation}
      displayType={StyleEnums.DisplayType.Warning}
      className={cssExports.v2}
    >
      {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.AnnualAccount.DividendSpaceWarning)}
    </SimpleMessage>
  ) : (
    <></>
  );
};

export default DividendSpaceWarning;
